/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { VendorAuctionWorksheetTaskListCriteria } from '../../models/vendor-auction-worksheet-task-list-criteria';
import { VendorAuctionWorksheetTaskListResultItem } from '../../models/vendor-auction-worksheet-task-list-result-item';

export interface ApiVendorTasklistVendorAuctionWorksheetTaskListPost$Params {

/**
 * User's Working Group
 */
  UserWorkingGroup?: String;
      body?: VendorAuctionWorksheetTaskListCriteria
}

export function apiVendorTasklistVendorAuctionWorksheetTaskListPost(http: HttpClient, rootUrl: string, params?: ApiVendorTasklistVendorAuctionWorksheetTaskListPost$Params, context?: HttpContext): Observable<StrictHttpResponse<Array<VendorAuctionWorksheetTaskListResultItem>>> {
  const rb = new RequestBuilder(rootUrl, apiVendorTasklistVendorAuctionWorksheetTaskListPost.PATH, 'post');
  if (params) {
    rb.header('UserWorkingGroup', params.UserWorkingGroup, {});
    rb.body(params.body, 'application/json');
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<Array<VendorAuctionWorksheetTaskListResultItem>>;
    })
  );
}

apiVendorTasklistVendorAuctionWorksheetTaskListPost.PATH = '/api/vendor/tasklist/VendorAuctionWorksheetTaskList';
